module.exports = __webpack_public_path__ + "img/vertical_3_5_8003.86253ca9.png";